import { render } from "./HandBag.vue?vue&type=template&id=5bfc4e31"
import script from "./HandBag.vue?vue&type=script&lang=js"
export * from "./HandBag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__